import { useEffect, useLayoutEffect } from "react";
const isWeb = process.env.TAMAGUI_TARGET === "web";
const isWindowDefined = typeof window !== "undefined";
const isServer = isWeb && !isWindowDefined;
const isClient = isWeb && isWindowDefined;
const isRSC = process.env.ENABLE_RSC ? (
  // note this is statically analyzed so no funny business, just access it without optional chaining
  // @ts-ignore
  import.meta.env ? (
    // @ts-ignore
    import.meta.env.SSR
  ) : false
) : false;
const idFn = () => {
};
const useIsomorphicLayoutEffect = isRSC ? idFn : isServer ? useEffect : useLayoutEffect;
const isChrome = typeof navigator !== "undefined" && /Chrome/.test(navigator.userAgent || "");
const isWebTouchable = isClient && ("ontouchstart" in window || navigator.maxTouchPoints > 0);
const isTouchable = !isWeb || isWebTouchable;
if (process.env.NODE_ENV === "development") {
  if (!process.env.TAMAGUI_TARGET) {
    console.warn(`Must set TAMAGUI_TARGET to "web" or "native"`);
  } else if (isClient && process.env.TAMAGUI_TARGET !== "web" && process.env.TAMAGUI_IGNORE_TARGET !== "1") {
    console.warn(
      `Must set TAMAGUI_TARGET to "web" for web apps - if you have window defined outside of the browser, set TAMAGUI_IGNORE_TARGET=1 to hide this`
    );
  }
}
export {
  isChrome,
  isClient,
  isRSC,
  isServer,
  isTouchable,
  isWeb,
  isWebTouchable,
  isWindowDefined,
  useIsomorphicLayoutEffect
};
//# sourceMappingURL=index.mjs.map
